import { render, staticRenderFns } from "./DrawerLayout.vue?vue&type=template&id=89d24820&scoped=true"
import script from "./DrawerLayout.vue?vue&type=script&lang=js"
export * from "./DrawerLayout.vue?vue&type=script&lang=js"
import style0 from "./DrawerLayout.vue?vue&type=style&index=0&id=89d24820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d24820",
  null
  
)

export default component.exports